<template>
    <div>
        <base-task-status
            :session_id="session.id"
            task_name="esg_report"
            :finishedHook="handleTaskStatusFinished"
        />
    </div>
</template>


<script>
import ApiService from "@/components/utils/api.service.js"
import BaseTaskStatus from "./BaseTaskStatus.vue"

export default {
    components: {
        BaseTaskStatus
    },
    props: {
        session: {
            type: Object,
            default: () => {}
        },
    },
    methods: {
        handleTaskStatusFinished: function(task_status) {
            return Promise.all([
                ApiService.get(`/amas/analysis/api/analysis/${this.session.id}/energy-report`),
                ApiService.get(`/amas/analysis/api/esg-report/analysis/${this.session.id}`),
            ])
            .then(([energyReportResponse, esgReportResponse]) => {
                let url = `/amas/analysis/${this.session.id}/esg-report`;
                let icon;
                let retrievedData = {};
                for (let item of esgReportResponse.data) {
                    retrievedData[item.risk_type] = item.risk_report;
                }
                // If any of the retrievedData is not null, threat it as success
                let success = Object.values(retrievedData).some(item => item !== null);
                if (success) {
                    icon = `
                        <a href="${url}">
                        <span class="circle circle-sm bg-success" data-toggle="tooltip" data-original-title="${this.$t("task_details:status:fetch:successful")}">
                            <i class="fa fa-check"></i>
                        </span>
                        </a>
                    `;
                } else {
                    icon = `
                        <a href="${url}">
                        <span class="circle circle-sm bg-light" data-toggle="tooltip" data-original-title="${this.$t("task_details:status:fetch:unsuccessful")}">
                                <i class="fa fa-close"></i>
                            </span>
                        </a>
                    `;
                }
                return icon;
            });
        }
    },
}
</script>